
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class MetalRateMasterGrid extends Serenity.EntityGrid<MetalRateMasterRow, any> {
        protected getColumnsKey() { return 'OMS.MetalRateMaster'; }
        protected getDialogType() { return MetalRateMasterDialog; }
        protected getIdProperty() { return MetalRateMasterRow.idProperty; }
        protected getInsertPermission() { return MetalRateMasterRow.insertPermission; }
        protected getLocalTextPrefix() { return MetalRateMasterRow.localTextPrefix; }
        protected getService() { return MetalRateMasterService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }

        protected addButtonClick() {

            let now = new Date();

            this.editItem(<MetalRateMasterRow>{
                CompanyId: Q.Authorization.userDefinition.CompanyId,
                CurrencyId: Q.Authorization.userDefinition.CurrencyId

            });
        }

        protected createSlickGrid() {
            var grid = super.createSlickGrid();
            var plugin = new Slick.ColumnGroup();//plugin to group

            var cols2 = grid.getColumns();
            for (let col of cols2) {
                //console.log(col);
                if (col.field == "RateOn") col.headerCssClass = "slickgrid-word-wrap";
            }
            grid.registerPlugin(plugin);

            plugin.enableColumnGrouping();

            return grid;
        }

        protected getSlickOptions() {
            let opt = super.getSlickOptions();
            opt.forceFitColumns = true;
            opt.editable = true;
            opt.headerRowHeight = 50;
            opt.autoEdit = true;
            //opt.forceFitColumns = true;
            return opt;
        }
    }
}